module.exports = __webpack_public_path__ + "img/telephone.bca1f132.png";